import { createReducer } from '@reduxjs/toolkit' ;
import { authUserWithCode, authUserWithCodeFailure, authUserWithCodeSuccess, merchantGetOrganization, merchantGetOrganizationFailure, merchantGetBrandList, merchantGetBrandListFailure, merchantGetBrandListSuccess, merchantGetOrganizationSuccess, merchantGetStoreListFromBrand, merchantGetStoreListFromBrandSuccess, merchantGetStoreListFromBrandFailure, merchantGetStoresDetailsOfBrand, merchantGetStoresDetailsOfBrandSuccess, merchantGetStoresDetailsOfBrandFailure, updateAppOrgName, setInitialRoute, getStoreConnection, getStoreConnectionSuccess, getStoreConnectionFailure, postStoreConnection, postStoreConnectionSuccess, postStoreConnectionFailure, deleteStoreConnection, deleteStoreConnectionSuccess, deleteStoreConnectionFailure, setReadAccessToken, setIntegrationAccessToken, merchantGetStoreCountFromBrandFailure, merchantGetStoreCountFromBrandSuccess, merchantGetStoreCountFromBrand, getAppAccessToken, getAppAccessTokenSuccess, getAppAccessTokenFailure, updateMixPanel, updateLoadingStatus } from '../actions/merchantAction';
import { ACTIVATE_STORE_MSG, DEACTIAVTE_STORE_MSG, FETCH_BRAND_LIST, FETCH_ORG_DETAILS, FETCH_STORE_DETAILS_MSG, FETCH_STORE_LIST, FETCH_STORE_STATUS_MSG } from '../../constants/merchantsConstants';
const initialState = {
	authMerchant : false,
    merchantAccessToken: '',
    merchantIntegrationToken: '',
    merchantTokenTime: 0,
    brandList: null,
    selectedBrandDetails: null,
    storesList: null,
    organizationSelected: null,
    brandIDSelected: null,
    brandDetails: null,
    storeDetails: null,
    storeCountList: null,
    storeConnection: null,
    storeConnectionStatus: null,
    apiLoading: false,
    apiLoadingStatus: '',
    appOrganization: '',
    initialRoute: '',
    appToken: null,
    mixPanelData: null
}

const merchantReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(authUserWithCode, (state) => {
			state.authMerchant = false;
            state.apiLoading = true;
        }).addCase(authUserWithCodeSuccess, (state, action) => {
            state.authMerchant = true;
            // console.log('CHECK ', sessionStorage.getItem('access_token_otter'), action.payload.code)
            if(sessionStorage.getItem('access_token_otter')){
                state.merchantIntegrationToken = action.payload.code;
                sessionStorage.setItem('integration_token_otter', action.payload.code)
            }
            else{
                state.merchantAccessToken = action.payload.code;
                sessionStorage.setItem('access_token_otter', action.payload.code)
            }
            
        }).addCase(authUserWithCodeFailure, (state, action) => {
            state.authMerchant = false;
			state.merchantAccessToken = null;
        })

        .addCase(merchantGetOrganization, (state, action) => {
            state.apiLoading = true;
            state.apiLoadingStatus = FETCH_ORG_DETAILS;
            action.access_token = state.merchantAccessToken
        }).addCase(merchantGetOrganizationSuccess, (state, action) => {
            state.apiLoadingStatus = '';
            state.organizationSelected = action.payload.data;
			state.apiLoading = false;
        }).addCase(merchantGetOrganizationFailure, (state, action) => {
            state.apiLoadingStatus = '';
			state.organizationSelected = {msg: 'ERROR', data: action.payload.data };
			state.apiLoading = false;
        })

        .addCase(merchantGetBrandList, (state, action) => {
            state.apiLoading = true;
            action.access_token = state.merchantAccessToken
            state.apiLoadingStatus = FETCH_BRAND_LIST;
        }).addCase(merchantGetBrandListSuccess, (state, action) => {
            state.brandList = action.payload.data;
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        }).addCase(merchantGetBrandListFailure, (state, action) => {
            state.apiLoadingStatus = '';
			state.brandList = {msg: 'ERROR'};
            state.apiLoading = false;
        }).addCase(updateLoadingStatus, (state, action) => {
            // console.log('status ',action.payload)
            state.apiLoadingStatus = action.payload.data.statustext;
            state.apiLoading = action.payload.data.status;
        })
        .addCase(merchantGetStoreListFromBrand, (state, action) => {
            state.apiLoading = true;
            state.selectedBrandDetails = action?.payload?.data;
            state.brandIDSelected = action?.payload?.data?.id;
            state.apiLoadingStatus = FETCH_STORE_LIST;
            action.access_token = state.merchantAccessToken
        }).addCase(merchantGetStoreListFromBrandSuccess, (state, action) => {
            state.apiLoadingStatus = '';
            state.storesList = action.payload.data;
            state.apiLoading = false;
        }).addCase(merchantGetStoreListFromBrandFailure, (state, action) => {
            state.apiLoadingStatus = '';
			state.storesList = {msg: 'ERROR'};
            state.apiLoading = false;
        })

        .addCase(merchantGetStoresDetailsOfBrand, (state, action) => {
            state.apiLoading = true;
            action.access_token = state.merchantAccessToken
            state.brandDetails = action.payload.data.brandID;
            state.apiLoadingStatus = FETCH_STORE_DETAILS_MSG;
        }).addCase(merchantGetStoresDetailsOfBrandSuccess, (state, action) => {
            state.apiLoadingStatus = '';
            state.storeDetails = action.payload;
            state.apiLoading = false;
        }).addCase(merchantGetStoresDetailsOfBrandFailure, (state, action) => {
            state.apiLoadingStatus = '';
			state.storeDetails = {msg: 'ERROR'};
            state.apiLoading = false;
        })

        .addCase(merchantGetStoreCountFromBrand, (state, action) => {
            state.apiLoading = true;
            action.access_token = state.merchantAccessToken
            state.brandDetails = action.payload.data.brandID;
        }).addCase(merchantGetStoreCountFromBrandSuccess, (state, action) => {
            state.storeCountList = action.payload.data;
            state.apiLoading = false;
        }).addCase(merchantGetStoreCountFromBrandFailure, (state, action) => {
			state.storeCountList = {msg: 'ERROR'};
            state.apiLoading = false;
        })

        .addCase(updateAppOrgName, (state, action) => {
            state.appOrganization =  action.payload.data;
            state.brandDetails = action.payload.data.brandID;
        })

        .addCase(setReadAccessToken, (state, action) => {
            state.merchantAccessToken =  action.payload.data;
        })

        .addCase(setIntegrationAccessToken, (state, action) => {
            state.merchantIntegrationToken =  action.payload.data;
        })
        .addCase(setInitialRoute, (state, action) => {
            state.initialRoute =  action.payload.data;
        })

        .addCase(getStoreConnection, (state, action) => {
            state.apiLoading = true;
            state.apiLoadingStatus = FETCH_STORE_STATUS_MSG;
            action.access_token = state.merchantIntegrationToken
        }).addCase(getStoreConnectionSuccess, (state, action) => {
            state.storeConnectionStatus = action.payload;
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        }).addCase(getStoreConnectionFailure, (state, action) => {
			state.storeConnectionStatus = {msg: 'ERROR', data: action.payload.data};
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        })


        .addCase(postStoreConnection, (state, action) => {
            state.apiLoading = true;
            state.apiLoadingStatus = ACTIVATE_STORE_MSG;
            action.access_token = state.merchantIntegrationToken
        }).addCase(postStoreConnectionSuccess, (state, action) => {
            state.storeConnection = action.payload.data;
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        }).addCase(postStoreConnectionFailure, (state, action) => {
			state.storeConnection = {msg: 'ERROR'};
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        })


        .addCase(deleteStoreConnection, (state, action) => {
            state.apiLoading = true;
            state.apiLoadingStatus = DEACTIAVTE_STORE_MSG;
            action.access_token = state.merchantIntegrationToken
        }).addCase(deleteStoreConnectionSuccess, (state, action) => {
            state.storeConnection = action.payload.data;
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        }).addCase(deleteStoreConnectionFailure, (state, action) => {
			state.storeConnection = {msg: 'ERROR'};
            state.apiLoadingStatus = '';
            state.apiLoading = false;
        })
        
        .addCase(getAppAccessToken, (state, action) => {
            state.apiLoading = true;
        }).addCase(getAppAccessTokenSuccess, (state, action) => {
            state.appToken = action.payload.data;
            state.apiLoading = false;
        }).addCase(getAppAccessTokenFailure, (state, action) => {
			state.appToken = null;
            state.apiLoading = false;
        }).addCase(updateMixPanel, (state, action)=>{
            state.mixPanelData = action.payload.data;
        })
    });

export default merchantReducer;
